module.exports = __webpack_public_path__ + "static/media/triangle.3c67db54.svg";